import { STM } from '../context/types';

export const fr_frStatements : STM[]  = [
  {
    "id": 1,
    "valueKey": "samen1",
    "title": "on travaille souvent avec les autres",
    "title_360_leadership": "stimule le travail d'équipe",
    "title_360_workenv": "on travaille souvent ensemble",
    "preferredType": "leadership"
  },
  {
    "id": 2,
    "valueKey": "samen2",
    "title": "l'équipe est plus importante que la personne", // le groupe est plus important qu'une personne
    "title_360_leadership": "favorise la réussite de l'équipe avant la sienne",
    "title_360_workenv": "l'équipe est plus importante que la personne",
    "preferredType": "workenv"
  },
  {
    "id": 3,
    "valueKey": "samen3",
    "title": "on travaille dur pour l'équipe",
    "title_360_leadership": "s'implique pour son équipe",
    "title_360_workenv": "on fait le maximum pour son équipe",
    "preferredType": "leadership"
  },
  {
    "id": 4,
    "valueKey": "conf1",
    "title": "on ne donne pas son avis si cela conduit à un désaccord",
    "title_360_leadership": "n'exprime pas son opinion si cela peut conduire à un conflit",
    "title_360_workenv": "on n'exprime pas son opinion si cela peut conduire à un conflit",
    "preferredType": "workenv"
  },
  {
    "id": 5,
    "valueKey": "conf2",
    "title": "on fait tout son possible pour éviter les disputes",
    "title_360_leadership": "fait tout pour éviter les disputes",
    "title_360_workenv": "on fait tout pour éviter les disputes",
    "preferredType": "leadership"
  },
  {
    "id": 6,
    "valueKey": "conf3",
    "title": "on respecte les règles et normes",
    "title_360_leadership": "s'assure qu'on respecte les règles et les normes",
    "title_360_workenv": "on respecte les règles et les normes",
    "preferredType": "workenv"
  },
  {
    "id": 7,
    "valueKey": "erken1",
    "title": "on est respecté par ses collègues et manager",
    "title_360_leadership": "garantit un environnement où on se respecte mutuellement",
    "title_360_workenv": "les collègues montrent du respect entre eux",
    "preferredType": "workenv"
  },
  {
    "id": 8,
    "valueKey": "erken2",
    "title": "on est reconnu pour ce qu'on fait",
    "title_360_leadership": "donne de la reconnaissance pour ce qu'on fait",
    "title_360_workenv": "on reçoit de la reconnaissance pour ce qu'on fait",
    "preferredType": "workenv"
  },
  {
    "id": 9,
    "valueKey": "erken3",
    "title": "votre apport est valorisé",
    "title_360_leadership": "valorise l'effort fourni",
    "title_360_workenv": "l'effort est apprécié",
    "preferredType": "leadership"
  },
  {
    "id": 10,
    "valueKey": "zorg1",
    "title": "on est bienveillant vis-à-vis des autres",
    "title_360_leadership": "est bienveillant et respectueux",
    "title_360_workenv": "on est bienveillant et respectueux",
    "preferredType": "leadership"
  },
  {
    "id": 11,
    "valueKey": "zorg2",
    "title": "on s'assure que chacun se sente bien", //on s'assure que les autres se sentent bien
    "title_360_leadership": "favorise une ambiance où chacun se sente bien",
    "title_360_workenv": "on fait en sorte que chacun se sente bien",
    "preferredType": "workenv"
  },
  {
    "id": 12,
    "valueKey": "zorg3",
    "title": "on aide ses collègues, ses clients ou d'autres partenaires", //on aide ses collègues, ses clients ou d'autres personnes
    "title_360_leadership": "favorise un climat d'entraide",
    "title_360_workenv": "on aide les collègues, les clients et/ou d'autres partenaires",
    "preferredType": "leadership"
  },
  {
    "id": 13,
    "valueKey": "gelijk1",
    "title": "on bénéficie de chances égales",
    "title_360_leadership": "traite tout le monde de manière équitable",
    "title_360_workenv": "chacun a des chances égales",
    "preferredType": "workenv"
  },
  {
    "id": 14,
    "valueKey": "gelijk2",
    "title": "votre âge, votre origine ou votre genre importe peu",
    "title_360_leadership": "ne fait pas de différence en fonction de l'âge, l'origine ou le genre",
    "title_360_workenv": "votre âge, votre origine ou votre genre ne fait pas la différence",
    "preferredType": "workenv"
  },
  {
    "id": 15,
    "valueKey": "gelijk3",
    "title": "les gens regardent ce que vous faites, pas qui vous êtes",
    "title_360_leadership": "nous évalue sur base de nos actions, pas de notre personnalité",
    "title_360_workenv": "on est jugé pour ses actes, pas pour sa personnalité",
    "preferredType": "leadership"
  },
  {
    "id": 16,
    "valueKey": "zelfsturing1",
    "title": "on a la liberté de décider ce qu'on fait",
    "title_360_leadership": "me laisse agir par moi-même",
    "title_360_workenv": "on a la liberté de décider ce qu'on fait",
    "preferredType": "workenv"
  },
  {
    "id": 17,
    "valueKey": "zelfsturing2",
    "title": "on choisit sa façon de travailler",
    "title_360_leadership": "me laisse déterminer ma propre façon de travailler",
    "title_360_workenv": "on peut déterminer sa propre manière de travailler",
    "preferredType": "leadership"
  },
  {
    "id": 18,
    "valueKey": "zelfsturing3",
    "title": "on planifie ses propres activités",
    "title_360_leadership": "me permet de déterminer mon propre emploi du temps",
    "title_360_workenv": "chacun peut planifier lui-même ses activités",
    "preferredType": "workenv"
  },
  {
    "id": 19,
    "valueKey": "macht1",
    "title": "je peux influencer le comportement des autres",
    "title_360_leadership": "influence mon travail",
    "preferredType": "leadership"
  },
  {
    "id": 20,
    "valueKey": "macht2",
    "title": "je dis ce qui doit être fait", // je suis celui/celle qui décide ce qui doit être fait
    "title_360_leadership": "dit ce qui doit être fait",
    "preferredType": "leadership"
  },
  {
    "id": 21,
    "valueKey": "macht3",
    "title": "je décide ce qui se passe", 
    "title_360_leadership": "décide ce qui doit être fait",
    "preferredType": "disabled"
  },
  {
    "id": 22,
    "valueKey": "voorspelbaar1",
    "title": "il y a de l'organisation et de la régularité dans le travail",
    "title_360_leadership": "encourage structure et régularité",
    "title_360_workenv": "il y a structure et régularité",
    "preferredType": "workenv"
  },
  {
    "id": 23,
    "valueKey": "voorspelbaar2",
    "title": "le travail se déroule habituellement comme prévu",
    "title_360_leadership": "s'assure que le planning soit respecté",
    "title_360_workenv": "les choses se passent généralement comme prévu",
    "preferredType": "leadership"
  },
  {
    "id": 24,
    "valueKey": "voorspelbaar3",
    "title": "on peut garder les valeurs traditionnelles et sa façon de penser",
    "title_360_leadership": "garantit le respect des traditions (valeurs, pensées, coutumes)",
    "title_360_workenv": "on conserve les traditions (valeurs, pensées, coutumes)",
    "preferredType": "workenv"
  },
  {
    "id": 25,
    "valueKey": "prestatie1",
    "title": "on peut montrer à quel point on est bon",
    "title_360_leadership": "m'encourage à donner le meilleur de moi-même",
    "title_360_workenv": "on peut montrer le meilleur de soi-même",
    "preferredType": "leadership"
  },
  {
    "id": 26,
    "valueKey": "prestatie2",
    "title": "on peut montrer ce qu'on est capable de faire",
    "title_360_leadership": "nous encourage à montrer ce qu'on peut faire",
    "title_360_workenv": "on peut démontrer son potentiel",
    "preferredType": "workenv"
  },
  {
    "id": 27,
    "valueKey": "prestatie3",
    "title": "on peut exceller dans ce qu'on fait",
    "title_360_leadership": "encourage à exceller dans ce que l'on fait",
    "title_360_workenv": "on peut exceller dans ce que l'on fait",
    "preferredType": "workenv"
  },
  {
    "id": 28,
    "valueKey": "zelfontplooi1",
    "title": "on peut continuer à apprendre",
    "title_360_leadership": "encourage la formation continue",
    "title_360_workenv": "on peut continuer à apprendre",
    "preferredType": "workenv"
  },
  {
    "id": 29,
    "valueKey": "zelfontplooi2",
    "title": "on peut approfondir ses connaissances",
    "title_360_leadership": "m'encourage à approfondir mes compétences",
    "title_360_workenv": "on peut approfondir ses connaissances",
    "preferredType": "leadership"
  },
  {
    "id": 30,
    "valueKey": "zelfontplooi3",
    "title": "on peut continuer à se développer",
    "title_360_leadership": "aide les autres à se développer",
    "title_360_workenv": "on peut continuer à se développer",
    "preferredType": "workenv"
  },
  {
    "id": 31,
    "valueKey": "duurzaam1",
    "title": "on offre un travail de qualité",
    "title_360_leadership": "s'assure que l'équipe délivre un travail qualitatif",
    "title_360_workenv": "on fournit un travail de qualité",
    "preferredType": "leadership"
  },
  {
    "id": 32,
    "valueKey": "duurzaam2",
    "title": "on respecte les clients et les autres relations", //on respecte les clients et d'autres personnes
    "title_360_leadership": "encourage l'équipe à respecter les clients et les autres relations",
    "title_360_workenv": "on respecte les clients et les autres relations",
    "preferredType": "workenv"
  },
  {
    "id": 33,
    "valueKey": "duurzaam3",
    "title": "on se soucie des gens, de la sécurité et de l'environnement",
    "title_360_leadership": "s'assure qu'on prend en compte l’individu, la sécurité et l’environnement",
    "title_360_workenv": "on prend en compte l’individu, la sécurité et l’environnement",
    "preferredType": "workenv"
  },
  {
    "id": 34,
    "valueKey": "integriteit1",
    "title": "on assume la responsabilité de ses actes",
    "title_360_leadership": "s'assure qu'on assume la responsabilité des ses actes",
    "title_360_workenv": "on assume la responsabilité de ses actes",
    "preferredType": "workenv"
  },
  {
    "id": 35,
    "valueKey": "integriteit2",
    "title": "les gens sont honnêtes",
    "title_360_leadership": "est honnête",
    "title_360_workenv": "on est honnête",
    "preferredType": "workenv"
  },
  {
    "id": 36,
    "valueKey": "integriteit3",
    "title": "on est discret avec des informations confidentielles",
    "title_360_leadership": "traite l'information personnelle et confidentielle avec soin",
    "title_360_workenv": "on traite l’information personnelle et confidentielle avec soin",
    "preferredType": "leadership"
  },
  {
    "id": 37,
    "valueKey": "innovatie1",
    "title": "on peut essayer de nouvelles façons de travailler",
    "title_360_leadership": "nous encourage à essayer de nouvelles façons de travailler",
    "title_360_workenv": "on peut essayer de nouvelles façons de travailler",
    "preferredType": "leadership"
  },
  {
    "id": 38,
    "valueKey": "innovatie2",
    "title": "on fait beaucoup de nouvelles expériences", //on peut découvrir beaucoup de nouvelles choses
    "title_360_leadership": "encourage à acquérir de nouvelles expériences",
    "title_360_workenv": "on fait beaucoup de nouvelles expériences",
    "preferredType": "workenv"
  },
  {
    "id": 39,
    "valueKey": "innovatie3",
    "title": "on peut trouver de nouveaux défis", 
    "title_360_leadership": "nous stimule à trouver de nouveaux défis",
    "title_360_workenv": "on peut trouver de nouveaux défis",
    "preferredType": "leadership"
  },
  {
    "id": 40,
    "valueKey": "daadkracht1",
    "title": "on travaille de sa propre initiative",
    "title_360_leadership": "encourage à initier soi-même des tâches",
    "title_360_workenv": "on se met au travail de sa propre initiative",
    "preferredType": "workenv"
  },
  {
    "id": 41,
    "valueKey": "daadkracht2",
    "title": "on veille à obtenir des résultats", // on s'assure que les résultats sont atteints
    "title_360_leadership": "s'assure que les résultats soient atteints",
    "title_360_workenv": "on veille à obtenir des résultats",
    "preferredType": "leadership"
  },
  {
    "id": 42,
    "valueKey": "daadkracht3",
    "title": "on fait tout son possible pour atteindre les objectifs",
    "title_360_leadership": "met tout en œuvre pour atteindre les objectifs visés",
    "title_360_workenv": "on met tout en œuvre pour que les objectifs visés soient atteints",
    "preferredType": "leadership"
  }
]

export const extra360Fr_FrStatements : Omit<STM, 'title'>[] = [
    // Additional statements used in Actual360 but not IdealClassic
    {
      id: 43,
      valueKey: 'daadkracht4',
      title_360_leadership:
          'prend des décisions',
      preferredType: 'leadership',
    },
    {
      id: 44,
      valueKey: 'gelijk4',
      title_360_leadership:
          "respecte et valorise les différences entre les membres de l'équipe",
      preferredType: 'leadership',
    },
    {
      id: 45,
      valueKey: 'prestatie4',
      title_360_leadership:
          'donne du feedback constructif',
      preferredType: 'leadership',
    },
]

